import gql from "graphql-tag";

export const UPDATE_AVATAR = gql`
    mutation UpdateAvatar($avatarUrl: String!) {
        updateAvatar (input: {
            avatarUrl: $avatarUrl
        }){
            user{
                profile{
                    avatarUrl
                }
            }
        }
    }
`;
